import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Container,
  Paper,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const SupportPage = (): React.JSX.Element => {
  return (
    <Box sx={{ color: '#f8fbff', py: 5 }}>
      <Container maxWidth="md">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 1,
            textAlign: 'center'
          }}
        >
          NextQuest Support
        </Typography>

        <Typography
          sx={{
            color: 'rgb(247, 249, 252)',
            textAlign: 'center',
            mb: 4
          }}
        >
          Find answers to common questions or contact us if you need additional help.
        </Typography>

        <Paper
          sx={{
            p: 3,
            mb: 4,
            backgroundColor: 'rgba(15, 23, 36, 0.95)',
            color: '#f8fbff',
            border: '1px solid rgba(148, 163, 184, 0.25)'
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
            Frequently Asked Questions
          </Typography>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why can't I create an account?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                Make sure you are using a valid email address and password and
                that all required registration fields have been completed.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why can't I log in?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                Verify that you are entering the same email address and password
                that you used when registering your NextQuest account.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why isn't Game Search loading?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                Game Search uses an external game data service. If that service
                is temporarily unavailable, search results may fail to load.
                Please try again later.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why aren't Featured Games loading?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                Featured Games also rely on the external game data service. If
                the service is unavailable, featured games may temporarily not
                appear on the homepage.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why can't I add a game to my library?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                You can browse and search for games without an account, but you
                must be logged in to save games to your personal library.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why doesn't my profile show favorites or statistics?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                Your profile statistics are based on games saved to your
                personal library. Favorite games must also be selected from
                games already saved in your library.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#f8fbff' }} />} sx={{ background: 'linear-gradient(90deg, rgba(15, 23, 36, 0.94), rgba(22, 34, 53, 0.94))', color: '#f8fbff' }}>
              <Typography fontWeight={600}>
                Why can't I leave a comment?
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ backgroundColor: '#162235', color: '#f8fbff' }}>
              <Typography>
                You must be logged into a registered NextQuest account before
                you can post comments on a game.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </Paper>

        <Paper
          sx={{
            p: 3,
            textAlign: 'center',
            backgroundColor: 'rgba(15, 23, 36, 0.95)',
            color: '#f8fbff',
            border: '1px solid rgba(148, 163, 184, 0.25)'
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
            Contact & Support
          </Typography>

          <Typography sx={{ color: '#f8fbff', mb: 3 }}>
            Still having trouble? Contact the NextQuest support team and we'll do our best to help.
          </Typography>

          <Button variant="contained" component="a" href="mailto:support@nextquesttracking.com" sx={{ fontWeight: 700, width: { xs: '100%', sm: 'auto' }, maxWidth: '100%', whiteSpace: 'normal', textAlign: 'center', wordBreak: 'break-word', px: 2 }}>
            support@nextquesttracking.com
          </Button>
        </Paper>
      </Container>
    </Box>
  )
}

export default SupportPage